
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			dragCount: 0
		};
	},
	props: {
		filesDisabled: Boolean
	},
	computed: {
		isDragging():boolean{
			return this.dragCount > 0;
		}
	},
	methods: {
		onDragStart(){
			if (this.filesDisabled) return;
			this.dragCount++;
		},
		onDragEnd(){
			if (this.filesDisabled) return;
			this.dragCount--;
		},
		onFileDrop(event:DragEvent){
			if (this.filesDisabled) return;
			this.dragCount = 0;
			if (!event.dataTransfer) {
				return;
			}
			if (event.dataTransfer.files.length == 0) {
				return;
			}
			let files = [] as File[];
			for (let file of event.dataTransfer.files) {
				files.push(file);
			}
			this.$emit("files", files);
		}
	},
	i18nEx: {
		componentPrefix: "components.chat-components"
	}
});
